import React from 'react';
interface ExchangeOrderFooterProps {
  formOfPayment: string;
  invoiceRefs: string[];
  remarks?: string;
  authorization: {
    approvedBy?: string;
    checkedBy?: string;
    chequeNo?: string;
  };
}
export function ExchangeOrderFooter({
  formOfPayment,
  invoiceRefs,
  remarks,
  authorization
}: ExchangeOrderFooterProps) {
  return <div className="space-y-5" data-id="element-295">
      {/* Form of Payment & Invoice Ref */}
      <div className="grid grid-cols-2 gap-6" data-id="element-296">
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-297">
          <p className="text-xs font-semibold text-neutral-700 mb-2" data-id="element-298">
            Form of Payment:
          </p>
          <p className="text-sm text-neutral-900 font-medium" data-id="element-299">
            {formOfPayment}
          </p>
        </div>

        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-300">
          <p className="text-xs font-semibold text-neutral-700 mb-2" data-id="element-301">
            Invoice Ref:
          </p>
          <div className="space-y-1" data-id="element-302">
            {invoiceRefs.map((ref, index) => <p key={index} className="text-xs text-neutral-900" data-id="element-303">
                {ref}
              </p>)}
          </div>
        </div>
      </div>

      {/* Remarks */}
      {remarks && <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4" data-id="element-304">
          <p className="text-xs font-semibold text-neutral-700 mb-2" data-id="element-305">
            Remarks:
          </p>
          <p className="text-xs text-neutral-600 leading-relaxed whitespace-pre-line" data-id="element-306">
            {remarks}
          </p>
        </div>}

      {/* Authorization Section */}
      <div className="border-t border-neutral-200 pt-5" data-id="element-307">
        <div className="grid grid-cols-3 gap-6" data-id="element-308">
          {/* Approved By */}
          <div data-id="element-309">
            <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-310">
              Approved by:
            </p>
            <div className="border-b-2 border-neutral-300 pb-1 mb-2 h-12 flex items-end" data-id="element-311">
              {authorization.approvedBy && <span className="text-xs text-neutral-900" data-id="element-312">
                  {authorization.approvedBy}
                </span>}
            </div>
            <p className="text-xs text-neutral-500" data-id="element-313">Signature</p>
          </div>

          {/* Checked By */}
          <div data-id="element-314">
            <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-315">
              Checked by:
            </p>
            <div className="border-b-2 border-neutral-300 pb-1 mb-2 h-12 flex items-end" data-id="element-316">
              {authorization.checkedBy && <span className="text-xs text-neutral-900" data-id="element-317">
                  {authorization.checkedBy}
                </span>}
            </div>
            <p className="text-xs text-neutral-500" data-id="element-318">Signature</p>
          </div>

          {/* Cheque No / PR / PAY# */}
          <div data-id="element-319">
            <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-320">
              Cheque No. / PR / PAY#:
            </p>
            <div className="border-b-2 border-neutral-300 pb-1 mb-2 h-12 flex items-end" data-id="element-321">
              {authorization.chequeNo && <span className="text-xs text-neutral-900" data-id="element-322">
                  {authorization.chequeNo}
                </span>}
            </div>
            <p className="text-xs text-neutral-500" data-id="element-323">Reference</p>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <p className="text-xs text-neutral-500 italic text-center pt-4 border-t border-neutral-200" data-id="element-324">
        This is a computer-generated document. No signature is required.
      </p>
    </div>;
}